import ApiService from '@/services/api.service'

const SchedulerOptionsService = {
    getAll() { 
      const requestData = {
        method: 'get',
        url: "/SchedulerOptions/",
        headers: {
        },
      }     
      return ApiService.customRequest(requestData);         
    },

    add(data){
        return ApiService.post(`/SchedulerOptions`, data);
    },

    update(Id,data){
        return ApiService.put(`/SchedulerOptions/${Id}`,data);
    },
  }
  
  export default SchedulerOptionsService;